import { FC } from 'react';

import { GlossaryTerm } from '../../types/Glossary';
import { ContentBlocks } from '../ContentBlocks';

interface Props {
  content: GlossaryTerm['content']['article'];
}

export const GlossaryArticle: FC<Props> = ({ content = [] }) => {
  if (content.length === 0) {
    return null;
  }

  return <ContentBlocks content={content} />;
};
